import {Redirect} from "@shopify/app-bridge/actions";

export const useGoTo = () => {
    const goTo = (location: string) => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app' + location);
    };

    return goTo;
};
